<i18n src="@/locales/modules/DeviceInventoryTranslate.json"></i18n>

<template>
	<el-dialog class="custom-dialog" :title="$t('Inventory')" :visible.sync="isSidebarActiveLocal">
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<vs-table ref="table" class="custom-table stack-table" :data="inventories">
					<div slot="header" class="flex flex-grow justify-end">
						<vs-button type="filled" class="w-auto sm:w-1/3 font-bold" @click="addNewData">{{ $t("Actions.AddNew") }}</vs-button>
					</div>

					<template slot-scope="{ data }">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<p class="inventories-item-name font-medium sm:truncate">{{ tr.name }}</p>
								</vs-td>

								<vs-td class="">
									<p class="max-w-xs inventories-item-street font-medium whitespace-pre-wrap">{{ tr.street }}</p>
								</vs-td>

								<vs-td class="whitespace-no-wrap text-right">
									<i class="nucleo nucleo-edit mr-3" @click.stop="editData(tr)"></i>
									<i class="nucleo nucleo-trash-can" @click.stop="showDeleteConfirm(tr.id)"></i>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>
		</PerfectScrollbar>

		<popup-create-or-update-inventory-item :isPopupActive="isPopupActive" @closePopup="toggleInventoryPopup" :data="popupData" />
	</el-dialog>
</template>

<script>
import _ from "lodash";
import PopupCreateOrUpdateInventoryItem from "./PopupCreateOrUpdateInventoryItem";

export default {
	components: {
		PopupCreateOrUpdateInventoryItem
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			popupData: {},
			isPopupActive: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		inventories() {
			return _.get(this.$store, "state.deviceManagement.inventories") || [];
		}
	},
	methods: {
		getListInventory() {
			try {
				this.$store.dispatch("deviceManagement/fetchInventories", {
					limit: -1,
					fetchPolicy: "no-cache"
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		toggleInventoryPopup(val = false) {
			this.isPopupActive = val;
		},
		addNewData() {
			this.popupData = {};
			this.toggleInventoryPopup(true);
		},
		editData(data) {
			this.popupData = data || {};
			this.toggleInventoryPopup(true);
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("deviceManagement/deleteInventory", id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteInventoryItemSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	}
};
</script>
